<template>
  <div class="usage-chart">
    <vs-loader :visible="!!usageData.isLoading" />
    <template v-if="chartData">
      <UsageChart
        :chartData="chartData"
        :options="chartOptions"
        :styles="{
          width: '99%'
        }"
      />
    </template>
  </div>
</template>

<script>
import UsageChart from './UsageChart'
import tooltipConfig from '@/misc/chartTooltip'
const MAIN_COLOR = '#16C6B9'
let _this = null

export default {
  components: {
    UsageChart
  },
  props: {
    usageData: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      chartData: null
    }
  },
  computed: {
    isChartAvailable () {
      if (!this.usageData ||
        !this.usageData.rateData ||
        !this.usageData.valueData) {
        return false
      }
      return true
    },
    chartOptions () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        elements: { point: { radius: 0.05 } },
        scales: {
          xAxes: [{
            gridLines: {
              display: false,
              drawBorder: false
            }
          }],
          yAxes: [{
            stacked: true,
            position: 'left',
            id: 'bar-axis',
            gridLines: {
              drawBorder: false
            },
            ticks: {
              // Include a dollar sign in the ticks
              callback: function (value, index, values) {
                return _this.$options.filters.numberFormat(value)
              }
            }
          }, {
            stacked: true,
            position: 'right',
            id: 'line-axis',
            gridLines: {
              display: false,
              drawBorder: false
            },
            ticks: {
              // Include a dollar sign in the ticks
              callback: function (value, index, values) {
                return _this.$options.filters.numberFormat(value, '0.0%')
              }
            }
          }]
        },
        tooltips: {
          ...tooltipConfig,
          intersect: false,
          callbacks: {
            label: function (tooltipItem, data) {
              if (tooltipItem.datasetIndex === 0) {
                return `${_this.usageData.chartInfo.valueTitle}: ${_this.$options.filters.numberFormat(tooltipItem.yLabel, '0,0')}`
              }
              if (tooltipItem.datasetIndex === 1) {
                return `${_this.usageData.chartInfo.rateTitle}: ${_this.$options.filters.numberFormat(tooltipItem.yLabel, '0.00%')}`
              }
            },
            labelTextColor: function (tooltipItem, chart) {
              return '#16C6B9'
            }
          }
        }
      }
    }
  },
  watch: {
    usageData () {
      this.setChartData()
    },
    isChartAvailable (changedValue) {
      this.setChartData()
    }
  },
  created () {
    _this = this
    this.setChartData()
  },
  methods: {
    async setChartData () {
      if (this.isChartAvailable) {
        this.chartData = await this.usageDataCollection()
      }
    },
    usageDataCollection () {
      let returnObject = {
        labels: [],
        datasets: [
          {
            type: 'bar',
            data: [],
            backgroundColor: 'rgba(22, 198, 185, 0.2)', // todo: set valiable
            hoverBackgroundColor: 'rgba(22, 198, 185, 0.65)',
            borderColor: MAIN_COLOR
          },
          {
            type: 'line',
            data: [],
            backgroundColor: 'rgba(0, 0, 0, 0)', // todo: set valiable
            hoverBackgroundColor: MAIN_COLOR,
            borderColor: MAIN_COLOR,
            pointHoverBackgroundColor: MAIN_COLOR,
            yAxisID: 'line-axis',
            borderWidth: 2,
            pointHoverRadius: 3
          }
        ]
      }
      this.usageData.valueData.forEach((usage, index) => {
        returnObject.labels.push(usage.date && usage.date.length === 8 ? `${usage.date.substr(4, 2)}/${usage.date.substr(6, 2)}` : '')
        returnObject.datasets[0].data.push(usage.val)
        returnObject.datasets[1].data.push(this.usageData.rateData[index].val)
      })
      return Promise.resolve(returnObject)
    }
  }
}
</script>

<style scoped lang="scss">
.usage-chart {
  position: relative;
  max-height: 467px;
  margin-bottom: 20px;
  padding: 20px;
  border: solid 1px $gray-300;
  background-color: white;
}
</style>
